// extracted by mini-css-extract-plugin
module.exports = {"alarm_page_content_wrapper":"Content_alarm_page_content_wrapper__1yzv5"};